/**
 * custom-cart-removeall.js
 *
 * Handles the "Remove all items" button inside the cart drawer.
 * Delegates to window.CartManager.clear() so the full update cycle
 * (gift sync, progress update, morph) fires exactly once.
 *
 * Dependencies:
 *   - .remove-all-cart button rendered by custom-cart-removeall.liquid
 *   - window.CartManager (custom-cart-manager.js)
 *   - custom-cart.css (modal styles)
 */

(function () {
  // Guard: attach listener only once across re-renders
  if (window._cartRemoveAllInit) return;
  window._cartRemoveAllInit = true;

  function getOrCreateModal() {
    let dialog = document.getElementById('remove-all-modal');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.id = 'remove-all-modal';
    dialog.className = 'remove-all-modal';
    dialog.setAttribute('aria-labelledby', 'remove-all-modal-title');
    dialog.innerHTML = `
      <div class="remove-all-modal__card">
        <div class="remove-all-modal__header">
          <p id="remove-all-modal-title" class="remove-all-modal__title">Remover tudo</p>
          <button type="button" class="remove-all-modal__close" aria-label="Fechar">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <p class="remove-all-modal__body">Todos os itens adicionados serão removidos e você terá que adicioná-los novamente.</p>
        <div class="remove-all-modal__actions">
          <button type="button" class="remove-all-modal__confirm">Sim, remover tudo</button>
          <button type="button" class="remove-all-modal__cancel">Cancelar</button>
        </div>
      </div>
    `;
    document.body.appendChild(dialog);
    return dialog;
  }

  function openModal(onConfirm) {
    const dialog = getOrCreateModal();
    const closeBtn = dialog.querySelector('.remove-all-modal__close');
    const confirmBtn = dialog.querySelector('.remove-all-modal__confirm');
    const cancelBtn = dialog.querySelector('.remove-all-modal__cancel');

    function handleConfirm() {
      dialog.close();
      onConfirm();
    }

    function onClose() {
      closeBtn.removeEventListener('click', dialog.close.bind(dialog));
      cancelBtn.removeEventListener('click', dialog.close.bind(dialog));
      confirmBtn.removeEventListener('click', handleConfirm);
    }

    closeBtn.addEventListener('click', () => dialog.close(), { once: true });
    cancelBtn.addEventListener('click', () => dialog.close(), { once: true });
    confirmBtn.addEventListener('click', handleConfirm, { once: true });
    dialog.addEventListener('close', onClose, { once: true });

    dialog.showModal();
    confirmBtn.focus();
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.remove-all-cart');
    if (!btn || btn.disabled) return;

    openModal(function () {
      const manager = window.CartManager;
      if (!manager) {
        console.error('[CartRemoveAll] CartManager not available');
        return;
      }

      btn.disabled = true;
      manager.clear().finally(() => {
        btn.disabled = false;
      });
    });
  });
})();
